import React, { useState } from 'react';
import NumberFormat from 'react-number-format';
import { Checkbox, Icon, Table } from 'semantic-ui-react';
import OrderItemsComponent from './order.items';

interface DeliveryCompProps {
    delivery: any
    colSpan?: number
    papaSelectMode?: boolean
    papaSelected?: boolean
    onPapaSelectToggle?: (deliveryId: number, checked: boolean) => void
    papaSelectable?: boolean
}

function OrderDeliveryComponent(props: DeliveryCompProps) {

    const [showItems, setShowItems] = useState(true)
    const colSpan = props.colSpan || 9;

    return (<React.Fragment>
        <Table.Row className="delivery-row">
            <Table.Cell className="cursor" colSpan={colSpan} data-label="Хүргэлт" onClick={() => setShowItems(!showItems)}>
                <div className="order-delivery-top cursor">
                    {props.papaSelectMode && props.papaSelectable ? <Checkbox
                        className="papa-delivery-checkbox"
                        checked={!!props.papaSelected}
                        onChange={(_e, data) => props.onPapaSelectToggle?.(props.delivery.id, !!data.checked)}
                        onClick={(e) => e.stopPropagation()}
                    /> : null}
                    <span className="delivery-date">
                        <Icon name="calendar outline"/>{props.delivery?.date}
                    </span>
                    &nbsp;
                    <span className="delivery-cost"> - Хүргэлтийн үнэ: - <NumberFormat displayType="text" value={props.delivery?.cost} thousandSeparator={true} suffix="₮" /></span>
                    &nbsp;
                    <span className="delivery-cost">
                        - Төрөл: {props.delivery?.deliveryProvider || 'OWN'}
                        {props.delivery?.externalDeliveryStatus ? ` (${props.delivery.externalDeliveryStatus})` : ''}
                    </span>
                </div>
            </Table.Cell>
        </Table.Row>
        { showItems ? <OrderItemsComponent items={props?.delivery?.items} colSpan={colSpan} /> : null }
        
    </React.Fragment>
    );
}

export default OrderDeliveryComponent;
